module.exports = __webpack_public_path__ + "static/media/WhatsApp_Logo1.ab47df1e.svg";